import { ExportConfig } from "@/lib/auth/export/export-types";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const MenuItem = ({
  label,
  selected,
  onClick,
}: {
  label: string;
  selected: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      className={cn(
        "w-full px-3 py-2 rounded-lg cursor-pointer",
        selected ? "bg-brand-600" : "bg-gray-50 hover:bg-gray-100",
      )}
      onClick={onClick}
    >
      <p
        className={cn(
          "font-semibold line-clamp-1",
          selected ? "text-white" : "text-gray-500",
        )}
      >
        {label}
      </p>
    </div>
  );
};

type ExportGroupMenuProps = {
  config: ExportConfig;
  activeGroup: string | null;
  groupRefs: React.MutableRefObject<Record<string, HTMLDivElement | null>>;
};

export const ExportGroupMenu = ({
  config,
  activeGroup,
  groupRefs,
}: ExportGroupMenuProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col h-fit min-w-[20vh] p-1.5 gap-0.5 bg-gray-50 rounded-xl border border-gray-200">
      {config.map((elem) => {
        if (elem.type !== "group") {
          return null;
        }
        return (
          <MenuItem
            key={elem.label}
            label={t(elem.label)}
            selected={activeGroup === elem.label}
            onClick={() =>
              groupRefs.current[elem.label]?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          />
        );
      })}
    </div>
  );
};
